/**
 * What: Centralized merchant-facing copy extracted from Shopify app components.
 * Transport / data-flow: Merges domain dictionaries consumed by apps/shopify components; no React, Worker, D1, Shopify, or provider calls.
 *
 */
import { shopifyComponentAudienceCopy } from './shopify-component-copy/audience.js';
import { shopifyComponentStudyCopy } from './shopify-component-copy/study.js';
import { shopifyComponentResultsCopy } from './shopify-component-copy/results.js';
import { shopifyComponentStoreIntelligenceCopy } from './shopify-component-copy/store-intelligence.js';
import { shopifyComponentStoreIntelligenceSyncHistoryCopy } from './shopify-component-copy/store-intelligence-sync-history.js';
import { shopifyComponentTestsHomeCopy } from './shopify-component-copy/tests-home.js';
import { shopifyComponentTestsIndexCopy } from './shopify-component-copy/tests-index.js';
import { shopifyComponentStoreIntelligenceBuildProgressCopy } from './shopify-component-copy/store-intelligence-build-progress.js';
import { shopifyComponentStoreIntelligenceStoreSettingsCopy } from './shopify-component-copy/store-intelligence-store-settings.js';
import { shopifyComponentMicroSurveysCopy } from './shopify-component-copy/micro-surveys.js';
import { shopifyComponentWebPixelCopy } from './shopify-component-copy/web-pixel.js';
import { shopifyComponentAppCopy } from './shopify-component-copy/app.js';
import { shopifyComponentIntegrationsCopy } from './shopify-component-copy/integrations.js';
import { shopifyComponentUsageCreditsCopy } from './shopify-component-copy/usage-credits.js';
import { shopifyComponentAppHomeCopy } from './shopify-component-copy/app-home.js';
import { shopifyComponentSettingsIndexCopy } from './shopify-component-copy/settings-index.js';
import { shopifyComponentBulkDeleteCopy } from './shopify-component-copy/bulk-delete.js';
import { shopifyComponentProductPairsCopy } from './shopify-component-copy/product-pairs.js';
export const shopifyComponentCopy = {
    studyBuilderDependency: {
        retry: 'Check setup again',
        productChange: 'Change product to {title}.',
        variantChange: 'Change variant to {title}.',
        comparisonChange: 'Change comparisons from {before} to {after}.',
        noComparisons: 'none',
        confirmTitle: 'Apply this change?',
        confirm: 'Apply change',
        cancel: 'Keep current setup',
        audiencePreserved: 'Your audience settings will stay the same.',
        resetOther: 'Related setup values will be reset.',
        undo: 'Undo',
        undoStale: 'Your setup has changed. Undo is no longer available for that change.',
        changed: {
            comparisons: 'Your comparison was cleared because the product, variant, or audience market changed.',
            brief: 'Your title and goal were reset for the new product.',
            questions: 'Your questions were reset to the standard questions for this setup.',
        },
        resets: {
            comparisons: 'The current comparison will be cleared.',
            brief: 'The title and goal will be reset for the new product.',
            questions: 'All added questions will be cleared and the standard questions rebuilt.',
        },
    },
    insightCategoryDetails: {
        category: 'Category',
        value: 'Value',
        count: 'Count',
        share: 'Share',
        close: 'Close',
        seeAll: 'See all categories',
    },
    ...shopifyComponentAudienceCopy,
    ...shopifyComponentStudyCopy,
    ...shopifyComponentResultsCopy,
    ...shopifyComponentStoreIntelligenceCopy,
    ...shopifyComponentStoreIntelligenceSyncHistoryCopy,
    ...shopifyComponentTestsHomeCopy,
    ...shopifyComponentTestsIndexCopy,
    ...shopifyComponentStoreIntelligenceBuildProgressCopy,
    ...shopifyComponentStoreIntelligenceStoreSettingsCopy,
    ...shopifyComponentMicroSurveysCopy,
    ...shopifyComponentWebPixelCopy,
    ...shopifyComponentAppCopy,
    ...shopifyComponentIntegrationsCopy,
    ...shopifyComponentUsageCreditsCopy,
    ...shopifyComponentAppHomeCopy,
    ...shopifyComponentSettingsIndexCopy,
    ...shopifyComponentBulkDeleteCopy,
    ...shopifyComponentProductPairsCopy,
};
//# sourceMappingURL=shopify-component-copy.js.map